import styled from '../../../../../utils/styling/styled';

import GlobalDistributionPin from '../../GlobalDistributionItems/GlobalDistributionPin';

export const Pin = styled(GlobalDistributionPin)`
  left: 44%;
  top: 7%;
  width: 5%;
`;
